import React from 'react';

export const HeroSection = () => {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-[#0A1128] via-[#1E3A8A] to-[#0F172A] pt-20">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-10 w-72 h-72 bg-[#3B82F6] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float"></div>
        <div className="absolute bottom-20 left-10 w-72 h-72 bg-[#10B981] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float" style={{ animationDelay: '2s' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white space-y-8 animate-fade-in-up">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight" style={{ fontFamily: 'Poppins, sans-serif' }}>
              Smart POS &<br />
              <span className="text-[#10B981]">Payment</span> Solutions
            </h1>

            <p className="text-xl text-gray-300 leading-relaxed max-w-xl">
              A modern fintech startup building seamless payment experiences for merchants across Europe and the Middle East.
            </p>
          </div>

          {/* Right Content - AI-generated hero image */}
          <div className="relative hidden lg:block animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <div className="relative">
              {/* Soft outer glow */}
              <div className="absolute -inset-6 bg-gradient-to-tr from-[#10B981]/25 to-[#3B82F6]/25 rounded-[2rem] blur-3xl opacity-70"></div>
              <img
                src="/hero.jpg"
                alt="Hand presenting a blank contactless card to a payment terminal"
                className="relative rounded-2xl shadow-2xl w-full object-cover h-[540px] border border-white/10"
                data-testid="hero-image"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
